import IQuestion from "./interfaces/IQuestion";

export default function publiconboardingQuiz(): IQuestion[] {
  return [
    {
      id: "cadastro",
      label: () => "",
      type: "component",
      session: "Operações",
      Component: () => <></>,
      enableNextButton: () => true,
      endStep: true,
    },
  ];
}
